import { UserInfo, IAdminInfoResponse, RoleInfo } from '../../Login/common/defaults';
import Api from '../../../services/Api';
import { ApiResponse } from 'apisauce';

export const GET_USER_ADMIN_INFO = 'GET_USER_ADMIN_INFO';
export const GET_ROLE_ADMIN_INFO = 'GET_ROLE_ADMIN_INFO';

export const saveAdminInfoToStore = (AllInfo: IAdminInfoResponse) => {
	return {
		type: GET_USER_ADMIN_INFO,
		value: AllInfo
	};
};

export const saveRoleAdminInfoToStore = (AllInfo: IAdminInfoResponse) => {
	return {
		type: GET_ROLE_ADMIN_INFO,
		value: AllInfo
	};
};

export const getUserAdminInfo = (url: string, active: boolean) => {
	return async dispatch => {
		try {
		  await Api.get(url + "?active="+active).then((result: ApiResponse<any>) => {
			dispatch(saveAdminInfoToStore(result.data));
			return Promise.resolve(result.data);
		  });
		} catch (ex) {
		  console.log(ex);
		  return Promise.reject(ex);
		}
	  };
}

export const getRoleAdminInfo = (url: string) => {
	return async dispatch => {
		try {
		  await Api.get(url).then((result: ApiResponse<any>) => {
			dispatch(saveRoleAdminInfoToStore(result.data));
			return Promise.resolve(result.data);
		  });
		} catch (ex) {
		  console.log(ex);
		  return Promise.reject(ex);
		}
	  };
}


export const addOrUpdateUser = (requestURL: string, user: UserInfo, active: boolean) => {
	return async dispatch => {
		try {
			user.userRoles.forEach(x => x.user = null);
			user.userRoles.forEach(x => x.role = null);
			user.userPermissions.forEach(x => x.user = null);
			user.userPermissions.forEach(x => x.permission = null);

		var request = {user, active};
		  await Api.post(requestURL, request)
		  .then((result: ApiResponse<any>) => {
			dispatch(saveAdminInfoToStore(result.data));
			return Promise.resolve(result.data);
		  });
		} catch (ex) {
		  console.log(ex);
		  return Promise.reject(ex);
		}
	  };
};

export const saveRole = (requestURL: string, role: RoleInfo) => {
	return async dispatch => {
		try {
		  await Api.post(requestURL, role)
		  .then((result: ApiResponse<any>) => {
			dispatch(saveAdminInfoToStore(result.data));
			return Promise.resolve(result.data);
		  });
		} catch (ex) {
		  console.log(ex);
		  return Promise.reject(ex);
		}
	  };
};
